import Header from './components/Header';
import './index.css';

function App() {
  return (
    <div className='container'>
      <Header />
    </div>
  );
}

export default App;
